import React from 'react';
import styles from './trash.css';

import clothClose from './icon-clothClose.png';
import clothOpen from './icon-clothOpen.png';


class Trash extends React.Component {
    constructor() {
        super()
    }
    render() {
        return (
            <div className={styles.blackCloth}
            >
                <div className={styles.clothBox}>
                    <img
                        className={styles.imgClothClose}
                        src={clothClose}
                    />
                    <img
                        className={styles.imgClothOpen}
                        src={clothOpen}
                    />
                </div>
            </div>
        )
    }
}

export default Trash